export const numberWithCommas = (num: number) => num.toLocaleString('ja-JP')
